<template>
    <div v-if="visible" class="toolbar">
        <button
            class="toolbar-btn"
            :class="{ active: activeTool === 'favorites' }"
            :title="$t('menu.favorites')"
            @click="toggle('favorites')"
        >
            <font-awesome-icon icon="star" />
        </button>
        <button
            class="toolbar-btn"
            :class="{ active: activeTool === 'help' }"
            :title="$t('about.open_manual')"
            @click="toggle('help')"
        >
            <font-awesome-icon icon="circle-question" />
        </button>
        <button
            v-if="chatEnabled"
            class="toolbar-btn"
            :class="{ active: activeTool === 'chat' }"
            :title="$t('ai_chat.title')"
            @click="toggle('chat')"
        >
            <font-awesome-icon icon="robot" />
        </button>
        <button
            class="toolbar-btn toolbar-btn--bottom"
            :class="{ active: activeTool === 'about' }"
            :title="$t('menu.about')"
            @click="toggle('about')"
        >
            <font-awesome-icon icon="circle-info" />
        </button>
    </div>
</template>

<script>
export default {
    name: 'ToolBar',
    props: {
        visible: { type: Boolean, default: false },
        chatEnabled: { type: Boolean, default: false },
        activeTool: { type: String, default: null }
    },
    methods: {
        toggle(tool) {
            this.$emit('toolChanged', this.activeTool === tool ? null : tool)
        }
    },
    emits: ['toolChanged']
}
</script>

<style scoped>
.toolbar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: var(--toolbar-width);
    background: #343A40;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    z-index: 11;
}

.toolbar-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 1em;
    width: 100%;
    height: var(--tool-header-height);
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
    border-right: 5px solid #343A40;
}

.toolbar-btn--bottom {
    margin-top: auto;
}

.toolbar-btn:hover {
    background: #525252;
}

.toolbar-btn.active {
    color: #a3ea18;
    border-right: 5px solid #a3ea18;
}

@media (max-width: 768px) {
    .toolbar {
        display: none;
    }
}
</style>
